import Grid from '@mui/material/Grid'
import Collapse from '@mui/material/Collapse'

import * as fecha from '../../utils/fecha'

export default function Lopd (props) {
  const { title, contacto, empresa, logotipo, date, Documento } = props

  return (
    <Grid container>
      <figure className='logo'>
        {logotipo}
      </figure>
      <Grid item xs={12} className='titulo'>
        <h4>
          {title}
        </h4>
      </Grid>
      <Collapse in={contacto !== null} mountOnEnter unmountOnExit>
        <Grid
          item
          xs={6}
          component='figure'
          className='datos cliente'
          data-title='datos del cliente'
        >
          <table>
            <tbody>
              <tr>
                <td colSpan={2}>
                  {
                    contacto && contacto.razon
                      ? contacto.razon
                      : contacto && contacto.alias
                        ? contacto.alias
                        : ''
                  }
                </td>
              </tr>
              <tr>
                <td>
                  N.I.F.: {contacto?.nif || ''}
                </td>
              </tr>
              <tr>
                <td>
                  {'Fecha de nacimiento: ' + (fecha.formatSlash(contacto?.fecha_nacimiento) || '')}
                </td>
              </tr>
              <tr>
                <td>
                  Domicilio: {contacto?.domicilio || ''}
                </td>
              </tr>
              <tr>
                <td>
                  {contacto?.codigo_postal + ', ' +
                   contacto?.ayuntamiento + ', ' +
                   contacto?.provincia}
                </td>
              </tr>
              <tr>
                <td>Tlfno: {contacto?.telefono || ''}</td>
              </tr>
              <tr>
                <td>Email: {contacto?.email_general || ''}</td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Documento
          contacto={contacto}
          empresa={empresa}
          date={date}
        />
        <footer>
          <address>
            {empresa.razon}{' · '}{empresa.nif}
            {' · '}{empresa.domicilio}{', '}
            {empresa.codigo_postal} {empresa.ayuntamiento} {'('}{empresa.provincia}{')'}
          </address>
          {empresa.email && <address>{empresa.email}</address>}
          {empresa.pie_factura && <address>{empresa.pie_factura}</address>}
        </footer>
      </Collapse>
    </Grid>
  )
}
